import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { EditarDocumentoCompraSkeleton } from "@/features/admin-compras-shared/EditarDocumentoCompraSkeleton";
import { AdminEditarOrdenCompraPage } from "@/features/admin-ordenes-compra/components/AdminEditarOrdenCompraPage";
import { ordenCompraAdminQueryOptions } from "@/features/admin-ordenes-compra/hooks/use-ordenes-compra";

export const Route = createFileRoute("/_authed-tw/admin/ordenes-compra/$id")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    tienePermisoEnSesion([PERMISOS.adminComprasSap])
      ? queryClient.ensureQueryData(ordenCompraAdminQueryOptions(id))
      : undefined,
  pendingComponent: EditarDocumentoCompraSkeleton,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminComprasSap]}>
      <AdminEditarOrdenCompraPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
